import axios from "axios";
import store from "@/store";
// import { useStore } from 'vuex'
// const store = useStore();
// axios.defaults.timeout = 5000; // ms
// axios.defaults.retry = 4; // count
// axios.defaults.retryDelay = 1000; // ms

let targetUrl = "";
if (location.origin.includes("local") || location.origin.includes("stage")) {
  // 로컬 / 스테이지 (stage-lifeedu-admin.carrotenglish.net)
  targetUrl = `https://stage-life-api.carrotenglish.net`;
  // targetUrl = `http://192.168.100.62:8500/`;
} else {
  // 운영
  targetUrl = `https://api-life.carrotapply.com`;
}
const instance = axios.create({
  baseURL: targetUrl,
  timeout: 1000 * 60 * 20,
  withCredentials: false,
});

instance.interceptors.request.use(
  (config) => {
    const token = store.getters.getAccessToken;
    config.headers.accessToken = token;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor
instance.interceptors.response.use(
  function (response) {
    // Do something with response data
    if (response.data.errorMessage !== undefined) {
      alert(response.data.errorMessage);
      // window.location.href = "https://life.carrotglobal.com/";
      // console.error("interceptors.response Message: ", response.data);
    }
    return response;
  },
  function (error) {
    // 서버가 응답은 했지만 에러 코드를 내려준 경우 (권한 없음 등)
    if (error.response && error.response.data) {
      const data = error.response.data;
      if (data.code === 501) {
        // 권한 없음(토큰 만료/무효): 토큰 비우고 alert 후 HQ 포털로 내보냄
        alert("접근권한이 없습니다. 로그인 후 이용해주세요.");
        store.commit("setAccessToken", {
          accessToken: "",
          staffInfo: {
            idx: 0,
            email: "",
            kname: "",
            ename: "",
            idxTeam: 0,
            idxOffice: 0,
            inOffice: "",
          },
        });
        window.location.href = "https://life.carrotglobal.com/";
        return Promise.reject(error);
      }
      if (data.message) {
        alert(data.message);
        return Promise.reject(error);
      }
    }
    // 응답 자체가 없을 때(진짜 네트워크 끊김)만 이 메시지를 표시
    alert("연결이 끊어졌습니다. 인터넷을 확인해보시고, 다시 접속해주세요");
    // window.location.href = "https://life.carrotglobal.com/";
    console.error("Network Error, Retry", error);
    return Promise.reject(error);
  }
);

export default instance;
